import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { getUserAgent } from '@/utils/index';

export default {
  namespace: 'knowLedgeWiki',
  state: {
    dataSource: [],
    bannerList: [],
    pageSize: '',
    pageNum: '',
    total: '',
    infoList: [],
    AllInfoList: [],
    loading: false,
  },
  reducers: {
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
        loading: false,
      };
    },
    setLoading(state, action) {
      return {
        ...state,
        // infoList: [],
        loading: action.payload,
      };
    },
    setBannerList(state, action) {
      return {
        ...state,
        bannerList: action.payload,
        loading: false,
      };
    },
    setInfoList(state, action) {
      const { AllInfoList, pageNum } = state;
      let DataSource;

      console.log(1, pageNum, 2, action);
      // if (pageNum !== action.payload.pageNum) {
      if (action.payload.pageNum === 1) {
        DataSource = action.payload.records;
      } else if (pageNum !== action.payload.pageNum) {
        DataSource = AllInfoList.concat(action.payload.records);
      } else {
        DataSource = AllInfoList;
      }
      return {
        ...state,
        pageNum: action.payload.pageNum,
        AllInfoList: DataSource,
        total: action.payload.total,
        infoList: DataSource,
        loading: false,
      };
      // } else {
      //   return {
      //     ...state,
      //     pageNum: action.payload.pageNum,
      //     total: action.payload.total,
      //     loading: false,
      //   };
      // }
    },
    setEmpty(state, action) {
      return {
        ...state,
        infoList: action.payload,
        AllInfoList: action.payload,
        total: '',
        pageNum: '',
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      const { callback = () => {}, parentId = '' } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = { parentId };
      const res = yield fetch.post(API.KNOWLEDGE_GET_LABEL, params);
      yield put({
        type: 'setDataSource',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback(res);
      }
    },
    *getBannerList(action, { put }) {
      let params = {
        location: '01',
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['supportVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_BANNER, params);
      console.log(res);
      yield put({
        type: 'setBannerList',
        payload: res.data,
      });
    },
    *getWikiByLabel(action, { put }) {
      const { labelId, callback = () => {}, pageNum, pageSize } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = {
        pageNum,
        pageSize,
        labelId,
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['appVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_INFO, params);
      yield put({
        type: 'setInfoList',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    *getEmpty(action, { put }) {
      yield put({
        type: 'setEmpty',
        payload: [],
      });
    },
    *getInfoClick(action, { put }) {
      const { id } = action.payload;
      yield fetch.get(API.KNOWLEDGE_SUM_CLICK, { id });
    },
  },
};
